export default {
    init() {
        this.monthViewCreateDropToggle();
    },
    monthViewCreateDropToggle() {
        let createBtn = $('.create-new-auction');

        createBtn.on('click', function (e) {
            e.preventDefault();
            let thisDrop = $(this).parent().find('.create-auction-drop');
            let drops = $('.create-auction-drop');
            drops.removeClass('current');
            thisDrop.addClass('current');

            let dropdowns = $('.create-auction-drop:not(.current)');
            dropdowns.removeClass('active');

            thisDrop.toggleClass('active');
        });


        let dropdowns = $('.create-auction-drop');

        $('body').on('click', function (e) {
            if (!createBtn.is(e.target) && createBtn.has(e.target).length === 0 && !dropdowns.is(e.target) && dropdowns.has(e.target).length === 0) {
                dropdowns.removeClass('active');
            }
        });
    },
    dayViewActionsToggle() {
        let moreActionsBtn = $('.column.actions .actions-more');

        moreActionsBtn.on('click', function (e) {
            e.preventDefault();

            let thisDrop = $(this).parent().find('.actions-drop');
            let drops = $('.actions-drop');
            drops.removeClass('current');
            thisDrop.addClass('current');

            let dropdowns = $('.actions-drop:not(.current)');
            dropdowns.removeClass('active');

            thisDrop.toggleClass('active');
        });

        let dropdowns = $('.actions-drop');

        $('body').on('click', function (e) {
            if (!moreActionsBtn.is(e.target) && moreActionsBtn.has(e.target).length === 0 && !dropdowns.is(e.target) && dropdowns.has(e.target).length === 0) {
                dropdowns.removeClass('active');
            }
        });
    }
}